import { useWallet } from "../context/web3.context";
import { Props } from "../types";

export default function OnlyOwner({ children }: Props): JSX.Element {
  const { isOwner } = useWallet();

  return (
    <>
      {isOwner ? (
        children
      ) : (
        <div className="max-w-screen-md">
          <h1 className="text-3xl font-bold text-center text-gray-900 dark:text-white">
            Only owner can perform this action
          </h1>
        </div>
      )}
    </>
  );
}
